import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from "@angular/core";
import {
  Membership, MembershipControllerService,
  Merchant,
  OrderControllerService, OrderItem,
  OrderReq, Payment,
  PaymentControllerService,
  PaymentMethod,
  PaymentMethodControllerService, PaymentReq,
  TableMerchant
} from "../../@services/gen";
import { lcdScreen, printz, secondScreen, calculateRoundingAmount, formatMonetaryValue } from "../../@services/utils";
import { AuthService } from '../../@services/auth.service';
import { PaymentService } from '../../@services/payment.service';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { Location } from '@angular/common';
import { StaffMealControllerService } from '../../@services/gen/api/staffMealController.service';
import { StaffMeal } from '../../@services/gen/model/staffMeal';
import { OrderService } from '../../@services/order.service';
import { TdDialogService } from '@covalent/core/dialogs';
import { CalculatorComponent } from '../../@components/calculator/calculator.component';
import { UserModel } from '../../@models/user.model';
import { LocalstorageService } from '../../@services/localstorage.service';
import { NotificationService } from '../../@services/notification.service';
import { PaymentMethodService } from '../../@services/payment-method.service';
import { Order } from 'src/app/@services/gen/model/order';
import { PaymentDiscountDialogComponent } from '../payment-discount-dialog/payment-discount-dialog.component';
import { ExtendedOrder } from '../pos/pos-split-bill-dialog/pos-split-bill-dialog.component';
import { ReceiptService } from '../../@services/receipt.service';
import { FeatureService } from '../../@services/feature.service';
import { RedeemPointsDialogComponent } from "../membership/redeem-points-dialog/redeem-points-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { BuzzerDialogComponent } from "../buzzer-dialog/buzzer-dialog.component";
import { PaymentReceiptDialogComponent } from "../payment-receipt-dialog/payment-receipt-dialog.component";
import { ManagerAuthService } from "../../@services/manager-auth.service";
import { StaffMealDialogComponent, StaffMealDialogResult } from "../staff-meal-dialog/staff-meal-dialog.component";
import { VoucherDialogComponent, VoucherDialogData, VoucherDialogResult } from '../voucher-dialog/voucher-dialog.component';

type MerchantVoucherCompat = Merchant & {
  voucherConfig?: {
    isAllowVoucher?: boolean;
  };
};

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  @ViewChild('referenceNoRef') referenceNoRef: ElementRef;
  @ViewChild('paidAmountRef') paidAmountRef: ElementRef;

  unpaidOrders: ExtendedOrder[] = [];
  paidAmount: number = 0;
  subtotal: number = 0;
  originalSubtotal: number = 0; // Store original subtotal before any discounts
  roundingAmount: number = 0;
  tax1Amount: number = 0;
  tax2Amount: number = 0;
  inclusiveTax: number = 0;
  chargesPercent: number = 0;
  chargesAmount: number = 0;
  netAmount: number = 0;
  totalAmount: number = 0;
  toBePaidTotal: number = 0;
  discountAmount: number = 0;
  discountRemarks;
  discountBy;
  discountPercentage: number = 0;
  tipsAmount: number = 0;
  discountItemAmount: number = 0;
  table: TableMerchant;
  paymentMethods: PaymentMethod[] = [];
  selectedPaymentMethod: PaymentMethod = { id: 1, name: 'Cash' };
  referenceNo: string = '';
  errMsg: string = '';
  bankNotes = [];
  loading = {
    submitting: false,
  };
  paymentDiscount: number = 0;
  private user: UserModel;
  private merchant: Merchant = {};
  selectedBankNote: { name: string; value: number };

  isMobile: boolean = false;

  membership: Membership;
  membershipRedeemPoint: number = 0;
  buzzerNo: string;
  isRemarkRequire: boolean = false;

  // Staff meal data
  staffMealData: StaffMealDialogResult | null = null;
  staffMealAmount: number = 0;
  isStaffMealEnabled: boolean = false;

  // Voucher data
  voucherData: VoucherDialogResult | null = null;
  voucherAmount: number = 0;
  isVoucherEnabled: boolean = false;

  constructor(
    private orderService: OrderControllerService,
    private paymentService: PaymentControllerService,
    private paymentMethodService: PaymentMethodControllerService,
    private customPaymentMethodService: PaymentMethodService,
    private customAuthService: AuthService,
    private customPaymentService: PaymentService,
    private router: Router,
    private location: Location,
    private staffMealService: StaffMealControllerService,
    private customOrderService: OrderService,
    private customReceiptService: ReceiptService,
    private fs: FeatureService,
    private ds: TdDialogService,
    private ls: LocalstorageService,
    private ns: NotificationService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    public dialog: MatDialog,
    private membershipControllerService: MembershipControllerService,
    private managerAuthService: ManagerAuthService
  ) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.user = this.customAuthService.getUser();
    this.merchant = this.ls.getMerchant();
    this.buzzerNo = "-";

    // Check if staff meal is enabled for this merchant
    this.isStaffMealEnabled = this.merchant?.staffMealConfig?.isAllowStaffMeal === true;

    // Check if voucher is enabled for this merchant
    const merchantWithVoucher = this.merchant as MerchantVoucherCompat;
    this.isVoucherEnabled = merchantWithVoucher?.voucherConfig?.isAllowVoucher === true;

    this.customPaymentMethodService.getCachePagedPaymentMethod(this.merchant.id).subscribe((res) => {
      let methods = res.content || [];

      // Filter out Staff Meal payment method if not enabled for this merchant
      if (!this.isStaffMealEnabled) {
        methods = methods.filter(m => !(m as any).name?.toLowerCase().replace(/\s+/g, '').includes('staffmeal'));
      }

      // Filter out Voucher payment method if not enabled for this merchant
      if (!this.isVoucherEnabled) {
        methods = methods.filter(m => !(m as any).name?.toLowerCase().includes('voucher'));
      }

      this.paymentMethods = methods;
      this.changePaymentMethod({ id: 1, name: 'Cash' });
    });

    this.customPaymentService.unpaidOrdersObs$.pipe(take(1)).subscribe((orders) => {
      if (orders.length == 0) {
        this.router.navigate(['/']);
        return;
      }

      this.unpaidOrders = orders.map((order) => order as ExtendedOrder);
      this.table = this.unpaidOrders[0].tableCustomer;

      this.unpaidOrders.forEach((x) => {
        return (x.discountAmount = 0);
      });
      this.calculateOrderTotalAmount();

      this.generateBankNotes(this.getToBePaidTotal());

      this.getMembership();

      this.updateLcdScreen();

    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed

    if (this.isMobile) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', '10px');
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', '10px');
    }
  }

  calculateOrderTotalAmount() {

    let calculatedValues = this.customOrderService.calculateOrderValues(this.unpaidOrders, this.discountAmount);

    console.log(calculatedValues);

    // Detect split bill by checking if any order has items with paidQuantity > 0
    const isSplitBill = this.unpaidOrders && this.unpaidOrders.some(o =>
      o.orderItems && o.orderItems.some(item => (item.paidQuantity || 0) > 0)
    );

    // Fix: For split bills, use payment-specific values that respect toBePaidQuantity
    this.subtotal = isSplitBill ? calculatedValues.paymentSubtotalOrder : calculatedValues.subtotal;
    this.originalSubtotal = isSplitBill ? calculatedValues.paymentSubtotalOrder : calculatedValues.subtotal;
    this.totalAmount = calculatedValues.totalAmount
    // Use the recalculated taxes that account for order-level discounts
    this.tax1Amount = calculatedValues.tax1Amount;
    this.tax2Amount = calculatedValues.tax2Amount;
    this.inclusiveTax = calculatedValues.inclusiveTax;
    this.chargesAmount = this.subtotal * (this.chargesPercent / 100)

    this.netAmount = Math.max(0, calculatedValues.netAmount + this.tipsAmount + this.chargesAmount - this.membershipRedeemPoint);
    // Don't overwrite this.discountAmount - it's set by user in updateDiscountAmount()
    // this.discountAmount = calculatedValues.discountAmount;
    this.discountItemAmount = calculatedValues.paymentDiscountItemOrder;

    // Get the pre-rounding base (strip rounding already baked in by order service)
    const preRoundingBase = isSplitBill
      ? calculatedValues.paymentTotalOrder - calculatedValues.roundingAmount
      : calculatedValues.totalAmount;
    const safePreRoundingBase = Math.max(0, preRoundingBase);
    this.voucherAmount = Math.min(Math.max(0, this.voucherAmount || 0), safePreRoundingBase);

    // Recalculate rounding AFTER voucher so the final total stays on the 5-cent boundary
    const amountForRounding = Math.max(0, safePreRoundingBase - this.voucherAmount);
    this.roundingAmount = formatMonetaryValue(calculateRoundingAmount(amountForRounding));

    this.toBePaidTotal = Math.max(
      0,
      amountForRounding + this.roundingAmount + this.tipsAmount + this.chargesAmount - this.membershipRedeemPoint - this.staffMealAmount
    );

    return 0;
  }

  generateBankNotes(netAmount: number) {
    function checkTenthLessThanFive(number) {
      const tenth = Math.floor(number % 10);
      return tenth <= 4.99;
    }

    let bankNotes = [];
    bankNotes.push({ name: `RM ${netAmount.toFixed(2)}`, value: +netAmount.toFixed(2) });

    if (checkTenthLessThanFive(+netAmount)) {
      let nearest5 = Math.ceil(netAmount / 5) * 5;
      bankNotes.push({ name: `RM ${nearest5}`, value: nearest5 });
    }

    let nearest10 = Math.ceil(netAmount / 10) * 10;
    bankNotes.push({ name: `RM ${nearest10}`, value: nearest10 });

    let nearest20 = Math.ceil(netAmount / 20) * 20;
    bankNotes.push({ name: `RM ${nearest20}`, value: nearest20 });

    let nearest50 = Math.ceil(netAmount / 50) * 50;
    bankNotes.push({ name: `RM ${nearest50}`, value: nearest50 });

    let nearest100 = Math.ceil(netAmount / 100) * 100;
    bankNotes.push({ name: `RM ${nearest100}`, value: nearest100 });

    let res = [];
    for (let bn of bankNotes) {
      if (res.findIndex((x) => x.name === bn.name) == -1) {
        res.push(bn);
      }
    }

    this.bankNotes = [...res];
  }

  submit() {
    this.errMsg = '';
    this.loading.submitting = true;
    this.pay();
  }

  private pay() {
    let merchant = this.ls.getMerchant();

    // Determine the correct payment method
    // If staff meal covers the full amount, use Staff Meal as payment method
    let effectivePaymentMethod = this.selectedPaymentMethod;
    if (this.staffMealData && this.staffMealAmount > 0) {
      const remainingAfterStaffMeal = this.getToBePaidTotal();
      if (remainingAfterStaffMeal <= 0) {
        // Staff meal covers full amount - use Staff Meal payment method
        const staffMealPaymentMethod = this.paymentMethods.find(p =>
          p.name.toLowerCase().replace(/\s+/g, '').includes('staffmeal')
        );
        if (staffMealPaymentMethod) {
          effectivePaymentMethod = staffMealPaymentMethod;
        }
      }
      // If remaining > 0, it's a split payment - use the secondary payment method (Cash, etc.)
    }

    let payment: PaymentReq = {
      merchant: merchant,
      tableId: this.table.id,
      paymentNo: this.generatePaymentNo(),
      paymentMethod: effectivePaymentMethod,
      ewalletReferenceNo: this.referenceNo || null,
      paymentItems: this.unpaidOrders.map((o) => {
        return {
          order: o,
        };
      }),
    };

    payment.totalAmount = this.subtotal;
    payment.paidAmount = this.paidAmount;
    payment.roundingAmount = this.roundingAmount;
    payment.tax1Amount = this.tax1Amount;
    payment.tax2Amount = this.tax2Amount;
    payment.inclusiveTax = this.inclusiveTax;
    payment.discountAmount = this.discountAmount;
    payment.discountPercentage = this.discountPercentage;
    payment.tipsAmount = this.tipsAmount;
    payment.discountItemAmount = this.discountItemAmount;
    payment.chargesAmount = this.chargesAmount;
    payment.changeAmount = +(this.paidAmount - this.getToBePaidTotal()).toFixed(2);
    payment.netAmount = this.getToBePaidTotal();
    payment.buzzerNo = this.buzzerNo == '-' ? null : this.buzzerNo;
    payment.discountRemarks = this.discountRemarks;
    payment.discountBy = this.discountBy;

    if (this.membership) {
      payment.membership = this.membership;
      payment.appliedMembershipPoint = this.membershipRedeemPoint;
    }

    // Add staff meal data if applied
    if (this.staffMealData && this.staffMealAmount > 0) {
      payment.staffMealAmount = this.staffMealAmount;
      payment.staffMeal = this.staffMealData.staffMeal as any;
    }

    // Add voucher data if applied
    if (this.voucherData && this.voucherAmount > 0) {
      (payment as any).voucherAmount = this.voucherAmount;
      (payment as any).voucher = this.voucherData.voucher;
      (payment as any).voucherCode = this.voucherData.voucher.code;
    }

    payment.paxNo = this.getPaxNo();

    this.loading.submitting = true;
    let dialogRef = this.ns.showNotification({
      message: 'Payment in progress...',
      icon: 'fa fa-sync',
      manualClose: true,
    });
    this.paymentService
      .upsertPaymentPost({
        payment: payment,
      })
      .subscribe(
        (res) => {

          dialogRef.close();

          if (this.fs.isFeatureEnabled('disableAutoPrint')) {
            this.dialogPrintReceipt(res.id);
          } else {
            this.printReceipt(res.id);
          }


          this.router.navigate(['/payment-success'], {
            queryParams: {
              paymentId: res.id,
            },
          });

          this.loading.submitting = false;
        },
        (error) => {
          dialogRef.close();

          // Display merchant-level validation errors
          if (error.error?.message) {
            if (error.error.message.includes('Staff meal is not enabled')) {
              this.errMsg = 'Error: Staff meal is not enabled at this outlet';
            } else if (error.error.message.includes('different HQ groups')) {
              this.errMsg = 'Error: Staff meal can only be used within your HQ group';
            } else {
              this.errMsg = `Error: ${error.error.message}`;
            }
          } else {
            this.errMsg = 'Error: Payment failed. Please try again.';
          }

          this.loading.submitting = false;
        }
      );
  }

  private printReceipt(paymentId: number) {
    let posId = this.ls.getPosId();

    for (let mvp of this.merchant.merchantVsPrinters.filter(x => x.posId === posId || !x.posId)) {
      let dialogRef = this.ns.showNotification({
        message: "Reprint receipt",
        manualClose: true,
        icon: "fa fa-sync"
      });

      if (mvp.printReceipt) {
        // chakz testing
        if (this.fs.isFeatureEnabled("receiptHTML")) {
          this.customReceiptService.getPaymentReceiptHtml(
            paymentId,
            mvp.printer.paperSizeType == "BIG" ? 85 : 56,
            mvp.printer.paperSizeType == "BIG" ? 570 : 380,
            (res) => {
              dialogRef.close();

              if (!res) {
                console.log("No receipt data");
                return;
              }

              printz(
                {
                  printerName: mvp.printer.printerName,
                  printerType: mvp.printer.printerType,
                  vendorId: mvp.printer.printerVendorId,
                  ipAddress: mvp.ipAddress,
                  macAddress: mvp.macAddress,
                  paperSizeType: mvp.printer.paperSizeType
                },
                [res],
                "html"
              );
            }
          );
        } else {
          this.customPaymentService.getPaymentReceipt(
            paymentId,
            mvp.printer.paperSizeType == "BIG" ? 45 : 32,
            (res) => {
              dialogRef.close();

              if (!res) {
                console.log("No receipt data");
                return;
              }

              printz(
                {
                  printerName: mvp.printer.printerName,
                  printerType: mvp.printer.printerType,
                  vendorId: mvp.printer.printerVendorId,
                  ipAddress: mvp.ipAddress,
                  macAddress: mvp.macAddress
                },
                [res]
              );
            }
          );
        }
      } else {
        dialogRef.close();
      }
    }
  }

  getToBePaidTotal() {
    return +this.toBePaidTotal.toFixed(2);
  }

  generatePaymentNo() {
    const prefix = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, '0');
    const suffix = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, '0');
    return `${prefix}-${suffix}`;
  }

  changePaymentMethod(item: PaymentMethod) {
    console.log('changePaymentMethod called with:', item.name);
    this.errMsg = '';
    this.selectedPaymentMethod = item;

    if (item.paymentMethodVsCharge) {
      this.chargesPercent = item.paymentMethodVsCharge.chargePercent;
    } else {
      this.chargesPercent = 0;
      this.chargesAmount = 0;
    }

    this.calculateOrderTotalAmount();

    // If Staff Meal payment method is selected, open the staff meal dialog
    // Match variations: "Staff Meal", "Staff Meals", "StaffMeal", etc.
    const itemNameLower = item.name.toLowerCase().replace(/\s+/g, '');
    console.log('Checking staff meal - normalized name:', itemNameLower);
    if (itemNameLower.includes('staffmeal')) {
      console.log('Opening staff meal dialog');
      this.displayStaffMealDialog();
      return;
    }

    if (item.name.toLowerCase().includes('voucher')) {
      this.displayVoucherDialog();
      return;
    }

    if (item.name.toLowerCase() !== 'cash') {
      this.paidAmount = this.getToBePaidTotal();
    } else {
      this.referenceNo = '';
      this.paidAmount = 0;
    }

    setTimeout(() => {
      if (item.name.toLowerCase() === 'cash') {
        // this.paidAmountRef.nativeElement.focus();
      } else {
        if (this.referenceNoRef) {
          this.referenceNoRef.nativeElement.focus();
        }
      }
    });
  }

  changeBankNote(item: { name: string; value: number }) {
    this.selectedBankNote = item;
    this.paidAmount = item.value;
  }

  back() {
    this.location.back();
  }

  isDisabled() {
    let changeAmount = (this.paidAmount - this.getToBePaidTotal()).toFixed(2);
    if (+changeAmount < 0) {
      return true;
    }

    if (this.paidAmount == 0 && this.getToBePaidTotal() > 0) {
      return true;
    }

    return false;
  }

  isCash() {
    return this.selectedPaymentMethod.name.toLowerCase() === 'cash';
  }

  isStaffMealPayment() {
    const nameLower = this.selectedPaymentMethod.name.toLowerCase().replace(/\s+/g, '');
    return nameLower.includes('staffmeal');
  }

  isVoucherPayment() {
    return this.selectedPaymentMethod?.name?.toLowerCase().includes('voucher');
  }

  shouldShowReferenceNo() {
    // Show reference no for non-cash payment methods, but NOT for Staff Meal or Voucher
    return !this.isCash() && !this.isStaffMealPayment() && !this.isVoucherPayment();
  }

  updateCashPaidAmount(evt: string) {
    this.paidAmount = +evt ?? 0;
  }

  updateDiscountAmount({ cashDiscount, discountPercentage }) {
    this.discountAmount = +cashDiscount ?? 0;
    this.discountPercentage = +discountPercentage ?? 0;
    // Remove divideBillDiscount - let order service handle discount distribution and tax calculation
    this.calculateOrderTotalAmount();
    this.changePaymentMethod(this.selectedPaymentMethod);
    this.generateBankNotes(this.getToBePaidTotal());
    this.updateLcdScreen();
  }


  updateTipsAmount(evt: string) {
    this.tipsAmount = +evt ?? 0;
    this.calculateOrderTotalAmount();
    this.changePaymentMethod(this.selectedPaymentMethod);
    this.generateBankNotes(this.getToBePaidTotal());
    this.updateLcdScreen();
  }

  displayDiscountDialog() {
    if (this.fs.isFeatureEnabled('discountPermission')) {
      this.checkDiscountPermission();
    } else {
      this.discountBy = this.user.username;

      this.isRemarkRequire = false;

      if (this.fs.isFeatureEnabled('disableDiscountRemark')) {
        this.isRemarkRequire = false;
      } else {
        this.isRemarkRequire = true;
      }

      this.discountProcess();
    }
    // reset discount
    this.updateDiscountAmount({ cashDiscount: 0, discountPercentage: 0 });
  }

  discountProcess() {
    this.ds
      .open(PaymentDiscountDialogComponent, {
        data: {
          discountRemarks: this.discountRemarks,
          isRemarkRequire: this.isRemarkRequire,
          totalAmount: this.originalSubtotal, // Use original subtotal for discount calculation base
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.discountRemarks = res.discountRemarks;
          this.updateDiscountAmount(res);
          this.updateSecondScreen();
        }
      });
  }

  displayBuzzerDialog() {
    // reset discount
    this.ds
      .open(BuzzerDialogComponent, {
        width: '700px',
        data: {
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.buzzerNo = res.selectedBuzzer;
        } else {
          this.buzzerNo = "-";
        }
      });
  }

  displayCalculator(type: 'cash' | 'discount' | 'tips') {
    this.selectedBankNote = null;
    let title = '';
    switch (type) {
      case 'cash':
        title = 'Enter tendered amount';
        break;
      case 'discount':
        title = 'Enter discount amount';
        break;
      case 'tips':
        title = 'Enter tips amount';
        break;
    }

    this.ds
      .open(CalculatorComponent, {
        data: { title: title },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          switch (type) {
            case 'cash':
              this.updateCashPaidAmount(res);
              break;
            case 'discount':
              this.updateDiscountAmount(res);
              break;
            case 'tips':
              this.updateTipsAmount(res);
              break;
          }
        }

        this.updateSecondScreen();
      });
  }

  private updateSecondScreen() {
    console.log(this.merchant.secondScreenBanner);
    if (!this.isMobile) {
      secondScreen({
        backgroundUrl: this.merchant.secondScreenBanner,
        merchantName: this.merchant.storeName || this.merchant.companyName,
        merchantLogoUrl: this.merchant['merchantLogoSmall'],
        orderItems: this.unpaidOrders.flatMap((o) => o.orderItems.filter((oi) => !oi.deleted)),
        payment: undefined,
        discountAmount: this.discountAmount,
        discountItemAmount: this.unpaidOrders.reduce((a, b) => a + b.discountItemAmount, 0),
        netAmount: this.getToBePaidTotal(),
        quantity: this.unpaidOrders
          .flatMap((o) => o.orderItems.filter((oi) => !oi.deleted))
          .map((x) => x.quantity)
          .reduce((a, b) => a + b, 0),
        roundingAmount: this.roundingAmount,
        subtotal: this.subtotal,
        tax1Amount: this.tax1Amount,
        tax2Amount: this.tax2Amount,
        totalAmount: this.subtotal,
      });
    }
  }

  divideBillDiscount(totalDiscount, orders) {
    const totalOrders = orders.length;

    const discountPerOrder = totalDiscount / totalOrders;

    let remainingDiscount = totalDiscount;
    const lastOrderIndex = orders.length - 1;

    for (let i = 0; i < lastOrderIndex; i++) {
      const currentDiscount = +discountPerOrder.toFixed(2);
      remainingDiscount -= currentDiscount;
      orders[i].discountAmount = currentDiscount;
    }

    orders[lastOrderIndex].discountAmount = remainingDiscount;
  }

  getMembership() {
    if (this.unpaidOrders[0]?.membership) {
      var tempMembership = this.unpaidOrders[0]?.membership;
      console.log(tempMembership);
      if (tempMembership) {
        this.membershipControllerService.getMembershipPost({ id: tempMembership.id }).subscribe(res => {
          this.membership = res;
          console.log(this.membership);
        })
      }
    }
  }

  getPaxNo() {
    return this.unpaidOrders[0]?.paxNo;
  }


  openMembershipRedeemDialog(): void {
    this.membershipRedeemPoint = 0;
    this.calculateOrderTotalAmount();
    this.generateBankNotes(this.getToBePaidTotal());

    const dialogRef = this.dialog.open(RedeemPointsDialogComponent, {
      width: '550px',
      data: {
        membership: this.membership,
        total: this.getToBePaidTotal()
      },
    });

    dialogRef.afterClosed().subscribe(res => {
      this.paidAmount = 0;
      if (res) {
        console.log('The dialog was closed');
        this.membershipRedeemPoint = res?.redeemPoints;
        this.updateMembershipRedeemPoint();
      }
    });
  }

  updateMembershipRedeemPoint() {
    this.calculateOrderTotalAmount();
    this.changePaymentMethod(this.selectedPaymentMethod);
    this.generateBankNotes(this.getToBePaidTotal());
  }

  clearMembershipPoint() {
    this.membershipRedeemPoint = 0;
    this.calculateOrderTotalAmount();
    this.changePaymentMethod(this.selectedPaymentMethod);
    this.generateBankNotes(this.getToBePaidTotal());
  }


  private dialogPrintReceipt(id: number) {
    this.ds
      .open(PaymentReceiptDialogComponent, {
        width: '550px',
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.printReceipt(id);
        }
      });
  }

  private updateLcdScreen() {
    if (this.fs.isFeatureEnabled("lcdScreen") && !this.isMobile) {
      lcdScreen([
        "Total Due",
        this.toBePaidTotal.toFixed(2)
      ]);
    }
  }

  private checkDiscountPermission() {
    this.managerAuthService.requireManagerAuth({ requireRemark: true }).subscribe(result => {
      if (result && result.success) {
        this.discountRemarks = result.remark;
        this.discountBy = result.username;
        this.discountProcess();
      }
    });
  }

  displayVoucherDialog() {
    const orderItems = [];
    if (this.unpaidOrders && this.unpaidOrders.length > 0) {
      this.unpaidOrders.forEach(order => {
        if (order.orderItems) {
          order.orderItems.forEach(item => {
            orderItems.push({
              name: (item as any).name || (item as any).posItemName || '',
              price: item.subtotal || ((item.price || 0) * (item.quantity || 1)) || 0,
              quantity: item.quantity || 1,
            });
          });
        }
      });
    }

    const dialogData: VoucherDialogData = {
      totalAmount: Math.max(0, this.netAmount || 0),
      merchantId: this.merchant?.id,
      orderItems: orderItems,
    };

    const dialogRef = this.dialog.open(VoucherDialogComponent, {
      data: dialogData,
      width: '600px',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result: VoucherDialogResult) => {
      if (result) {
        this.voucherData = result;
        this.voucherAmount = Math.max(0, result.voucherAmount || 0);
        this.calculateOrderTotalAmount();

        // After applying voucher, switch to Cash for remaining payment
        const cashPaymentMethod = this.paymentMethods.find(p => p.name.toLowerCase() === 'cash') || { id: 1, name: 'Cash' };
        this.selectedPaymentMethod = cashPaymentMethod;

        const remainingToPay = this.getToBePaidTotal();
        this.paidAmount = 0;
        this.generateBankNotes(remainingToPay > 0 ? remainingToPay : 0);
        this.updateLcdScreen();
        this.updateSecondScreen();
      } else {
        // User cancelled dialog - switch back to Cash
        const cashPaymentMethod = this.paymentMethods.find(p => p.name.toLowerCase() === 'cash') || { id: 1, name: 'Cash' };
        this.selectedPaymentMethod = cashPaymentMethod;
        this.referenceNo = '';
        this.paidAmount = 0;
      }
    });
  }

  clearVoucher() {
    this.voucherData = null;
    this.voucherAmount = 0;
    this.calculateOrderTotalAmount();
    this.generateBankNotes(this.getToBePaidTotal());
    this.updateLcdScreen();
  }

  getPaymentMethodIcon(category: string): string {
    const iconMap: { [key: string]: string } = {
      'cash':      'fas fa-money-bill-wave text-success',
      'visa':      'fas fa-credit-card text-primary',
      'card':      'fas fa-credit-card text-primary',
      'ewallet':   'fas fa-mobile-alt text-info',
      'voucher':   'fas fa-ticket-alt text-warning',
      'staffmeal': 'fas fa-utensils text-secondary',
      'delivery':  'fas fa-truck text-info',
    };
    return iconMap[category?.toLowerCase()] ?? 'fas fa-credit-card text-muted';
  }

  displayStaffMealDialog() {
    console.log('displayStaffMealDialog called');
    // Calculate the current total to show in dialog
    const currentTotal = this.getToBePaidTotal() + this.staffMealAmount; // Add back any existing staff meal amount
    console.log('Opening dialog with total:', currentTotal);

    const dialogRef = this.dialog.open(StaffMealDialogComponent, {
      width: '500px',
      data: {
        totalAmount: currentTotal,
      },
    });
    console.log('Dialog opened, dialogRef:', dialogRef);

    dialogRef.afterClosed().subscribe((res: StaffMealDialogResult) => {
      if (res) {
        this.staffMealData = res;
        this.staffMealAmount = res.staffMealAmount;
        this.calculateOrderTotalAmount();

        // After applying staff meal, switch to Cash for remaining payment
        // This prevents infinite loop of reopening staff meal dialog
        const cashPaymentMethod = this.paymentMethods.find(p => p.name.toLowerCase() === 'cash') || { id: 1, name: 'Cash' };
        this.selectedPaymentMethod = cashPaymentMethod;

        // If remaining amount is 0, set paid amount to 0 (no additional payment needed)
        // Otherwise, generate bank notes for the remaining amount
        const remainingToPay = this.getToBePaidTotal();
        if (remainingToPay <= 0) {
          this.paidAmount = 0;
        } else {
          this.paidAmount = 0; // User needs to select/enter cash amount
        }

        this.generateBankNotes(remainingToPay > 0 ? remainingToPay : 0);
        this.updateLcdScreen();
        this.updateSecondScreen();
      } else {
        // User cancelled dialog - switch back to Cash
        const cashPaymentMethod = this.paymentMethods.find(p => p.name.toLowerCase() === 'cash') || { id: 1, name: 'Cash' };
        this.selectedPaymentMethod = cashPaymentMethod;
        this.referenceNo = '';
        this.paidAmount = 0;
      }
    });
  }

  clearStaffMeal() {
    this.staffMealData = null;
    this.staffMealAmount = 0;
    this.calculateOrderTotalAmount();
    this.generateBankNotes(this.getToBePaidTotal());
    this.updateLcdScreen();
  }

}
